import { Application } from "@hotwired/stimulus"
import * as ActiveStorage from "@rails/activestorage"

const application = Application.start()

// Configure Stimulus development experience
if (__AWS_ENV__ !== 'production') {
  application.debug = true
}
window.Stimulus   = application

ActiveStorage.start()

export { application }
